import { render } from "./DailyStats.vue?vue&type=template&id=2b723c04&scoped=true"
import script from "./DailyStats.vue?vue&type=script&lang=js"
export * from "./DailyStats.vue?vue&type=script&lang=js"

import "./DailyStats.vue?vue&type=style&index=0&id=2b723c04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b723c04"]])

export default __exports__